<template>
  <div class="form-group">
    <label for="roles" class="control-label col-sm-4">Roles:</label>
    <div class="col-sm-8">
      <multiselect v-if="roles"
          :ref="`multiselect-roles`"
          v-model="selection"
          :options="options"
          placeholder="Bitte wählen Sie eine Option"
          :multiple="true"
          :hideSelected="true"
          track-by="id"
          label="value"
      ></multiselect>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['roles', 'options'],
    name: "ResourceRow",
    data () {
      return {
        isLoading: false
      }
    },
    computed: {
      selection: {
        get: function () {
          return this.roles
        },
        set: function (newValue) {
          this.$emit('select', newValue )
        }
      }
    },
    methods: {
      getOptions (action) {
        this.isLoading = true
        Api().get(`/frontend/permission/${this.resource}?action=${action}`)
          .then(response => {
            this.isLoading = false
            this.options = response.data
          })
      },
      updateProp (event) {
        let props = []
        this.selection.forEach(x => {
          props.push(x.id)
        })
        this.$emit('select', props )
      }
    }
  }
</script>

<style scoped>
</style>
